import React, { useEffect, useContext } from 'react';
import { useFormContext } from 'react-hook-form';

// Redux
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'redux/store';
import { RootState } from 'redux/schemas';
import { getCollectionFolder } from 'redux/selectors/collections';
import { fetchFolder } from 'redux/actions/collections';
import { CollectionFolder } from 'redux/schemas/models/collections';

import NvRadioButton from 'shared/components/inputs/nv-radio-button';
import { folderLessonSortKeys } from 'content-library/components/collection-home/folder-lecture-list';
import { useOnClickExpand } from './collection-row';
import { CollectionListModalContext, CollectionListModalType } from './collection-list-modal-body';

type CollectionFolderProps = {
  folderId: number;
  collectionName: string;
  catalogId?: string;
  collectionId?: number;
};

const CollectionRowFolder = (props: CollectionFolderProps) => {
  const { folderId, collectionName, catalogId, collectionId } = props;
  const {
    selectedFolderId,
    setSelectedFolderId,
    setSelectedCollectionName,
    collectionListModalType,
  } = useContext(CollectionListModalContext);
  const { getValues, setValue, trigger, watch } = useFormContext() || {};
  const destinationFolderId = watch?.('destinationFolderId');

  const currentfolder: CollectionFolder = useSelector((state: RootState) => getCollectionFolder(state, folderId));

  const dispatch = useAppDispatch();
  const { isExpanded, setIsLoading } = useOnClickExpand();

  useEffect(() => {
    if (isExpanded) {
      dispatch(fetchFolder({
        folderId,
        pageIndex: 1,
        sorting: [`${folderLessonSortKeys[0]}&order=asc`],
      })).then(() => {
        setIsLoading(false);
      });
    }
  }, [dispatch, folderId, isExpanded, setIsLoading]);

  const onSelectFolder = (e) => {
    if (collectionListModalType === CollectionListModalType.LESSON_TRANSFER) {
      if (getValues('destinationCatalogId') !== catalogId) {
        setValue('destinationCatalogId', catalogId);
        setValue('destinationCollectionId', collectionId);
        setValue('destinationCollectionName', collectionName);
      }
      setValue('destinationFolderId', e.currentTarget.value);
      trigger();
    } else {
      setSelectedFolderId(e.currentTarget.value);
      setSelectedCollectionName(collectionName);
    }
  };

  const isFolderChecked = () => {
    if (collectionListModalType === CollectionListModalType.LESSON_TRANSFER) {
      return currentfolder.id === +destinationFolderId;
    }
    return currentfolder.id === +selectedFolderId;
  };

  return (
    <div className='ml-5'>
      <NvRadioButton
        withForm={collectionListModalType === CollectionListModalType.LESSON_TRANSFER}
        name='destinationFolderId'
        value={currentfolder.id}
        label={currentfolder.title}
        className='d-flex'
        labelClassName='text-wrap mw-100 text-regular font-weight-bolder ellipsis'
        onChange={onSelectFolder}
        checked={isFolderChecked()}
        labelIcon='admin-folder'
        labelIconSize='small'
        labelIconClassName='ml-2 text-gray-3 pr-2'
      />
    </div>
  );
};

export default CollectionRowFolder;
